/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
function e(e, t, r, o) {
  var c,
      f = arguments.length,
      n = f < 3 ? t : null === o ? o = Object.getOwnPropertyDescriptor(t, r) : o;
  if ("object" == typeof Reflect && "function" == typeof Reflect.decorate) n = Reflect.decorate(e, t, r, o);else for (var l = e.length - 1; l >= 0; l--) {
    (c = e[l]) && (n = (f < 3 ? c(n) : f > 3 ? c(t, r, n) : c(t, r)) || n);
  }
  return f > 3 && n && Object.defineProperty(t, r, n), n;
}

export { e as _ };